export default __webpack_public_path__ + "static/media/img-egt-abp@2x.7e0e9652.png";